import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '1202', label: '1202: Devolução de venda no estado' },
			{ value: '2202', label: '2202: Devolução de venda outros estados' },
			{ value: '1411', label: '1411: Devolução de venda sujeita ao ICMS-ST no estado' },
			{ value: '2411', label: '2411: Devolução de venda sujeita ao ICMS-ST outros estados' },
			{ value: '1949', label: '1949: Outra entrada de mercadoria não especificada no estado' },
			{ value: '2949', label: '2949: Outra entrada de mercadoria não especificada outros estados' },
			{ value: '5102', label: '5102: Venda de mercadoria no estado' },
			{ value: '6102', label: '6102: Venda de mercadoria outros estados' },
			{ value: '6108', label: '6108: Venda de mercadoria a não contribuinte outros estados' },
			{ value: '5202', label: '5202: Devolução de compra no estado' },
			{ value: '6202', label: '6202: Devolução de compra outros estados' },
			{ value: '5405', label: '5405: Venda de mercadoria sujeita ao ICMS-ST no estado' },
			{ value: '5411', label: '5411: Devolução de compra sujeita ao ICMS-ST no estado' },
			{ value: '6411', label: '6411: Devolução de compra sujeita ao ICMS-ST outros estados' },
			{ value: '5910', label: '5910: Remessa em bonificação, doação ou brinde no estado' },
			{ value: '6910', label: '6910: Remessa em bonificação doação ou brinde outros estados' },
			{ value: '5911', label: '5911: Remessa de amostra grátis no estado' },
			{ value: '6911', label: '6911: Remessa de amostra grátis outros estados' },
			{ value: '5927', label: '5927: Baixa de estoque decorrente de perda, roubo ou deterioração' },
			{ value: '5949', label: '5949: Outra saída de mercadoria ou serviço não especificado' },
			{ value: '5119', label: '5119: Venda de mercadoria entregue por conta e ordem do adquirente' },
			{ value: '6120', label: '6120: Venda de mercadoria entregue pelo vendedor em venda à ordem' },
			{ value: '5923', label: '5923: Remessa de mercadoria por conta e ordem de terceiros no estado' },
			{ value: '6923', label: '6923: Remessa de mercadoria por conta e ordem de terceiros outros estados' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

